import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { QueryClient } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import React from 'react'
import { createRoot } from 'react-dom/client'

import { AuthProvider } from './lib/auth/provider'
import { CopyProvider } from './lib/copy/copy-provider'
import { wireDeepLinks } from './lib/native/oauth/deep-link'
import { applyStatusBar } from './lib/native/status-bar'
import { wireOnlineManager } from './lib/native/network'
import { queryPersister } from './lib/persistence/persister'
import { routeTree } from './routeTree.gen'
import './styles/globals.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      networkMode: 'offlineFirst',
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
})

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: { queryClient, auth: undefined! },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

applyStatusBar('dark')
wireOnlineManager()
wireDeepLinks((to) => {
  router.navigate({ to: to as never })
})

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('root element missing')

createRoot(rootEl).render(
  <React.StrictMode>
    <AuthProvider>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister: queryPersister }}
      >
        <CopyProvider>
          <RouterProvider router={router} />
        </CopyProvider>
      </PersistQueryClientProvider>
    </AuthProvider>
  </React.StrictMode>,
)
